import * as React from 'react';

function SvgAddress(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M6.83 12.5v2.3h-.95l-2.46 5.78h17.2l-2.46-5.77h-.99V12.5h.99c.92 0 1.75.55 2.11 1.4l2.47 5.77a2.3 2.3 0 01-2.12 3.21H3.42a2.3 2.3 0 01-2.11-3.22l2.46-5.76a2.3 2.3 0 012.11-1.4h.95zM12.02.04a5.61 5.61 0 015.71 5.5c0 2.54-3.89 10.9-4.67 12.55-.19.39-.6.64-1.04.64-.45 0-.86-.25-1.04-.64-.78-1.65-4.67-10.01-4.67-12.55A5.6 5.6 0 0112 .04zm0 2.2a3.37 3.37 0 00-3.43 3.3c0 1.3 1.82 5.78 3.43 9.37 1.6-3.59 3.43-8.07 3.43-9.37 0-1.82-1.54-3.3-3.43-3.3zm0 1.95a1.56 1.56 0 110 3.12 1.56 1.56 0 010-3.12z" />
    </svg>
  );
}

export default SvgAddress;
